import React, { useEffect, useRef, useState } from 'react';
import styles from './custom-dropdown.module.scss';

interface IProps {
  list: Array<any>
  modifiers?: string
  label: string
  name: string
  curried?: boolean
  value: string
  resetError?: () => void
  error?: boolean
  selectedValues?: Array<any>
  handleOnChange: any
  placeholder: string
}

const CustomDropdown = React.memo(function (props: IProps) {
  const [inputValue, setInputValue] = useState('')
  const [focused, setFocused] = useState(false)
  const [list, updateList] = useState(props.list)
  const container = useRef<HTMLInputElement>(null)


  const clickedOuSide = (e: any) => {
    if (container.current && !container.current.contains(e.target)) {
      setFocused(false)
    }
  }

  useEffect(() => {
    window.addEventListener('click', clickedOuSide)
    return () => window.removeEventListener('click', clickedOuSide)
  }, [])

  const handleChange = (value: string) => {
    if (props.curried) {
      props.handleOnChange()(value)

    } else {
      props.handleOnChange(value)
    }
    setInputValue(value)
    updateList([...props.list].filter(v => v.toLowerCase().includes(value.toLowerCase())))

  }

  const handleClick = (value: string) => {
    setInputValue(value)
    if (props.curried) {
      props.handleOnChange()(value)
    } else {
      props.handleOnChange(value)
    }
    setTimeout(function () {
      setFocused(false)
    }, 0);
  }


  const handleFocus = () => {
    setFocused(true)
    
    if (props.resetError) {
      props.resetError()
    }
  }


  return (
    <div className={`${styles.inputField} ${props.modifiers ? props.modifiers : ''}`} >
      {props.label && <label htmlFor={props.name} className={styles.inputLabel}>{props.label}</label>}
      <div ref={container} className={`${styles.inputWrapper} ${props.error ? styles.errorState : ''}`}>
        <input
          id={props.name}
          className={styles.input}
          onFocus={handleFocus}
          placeholder={props.placeholder}
          type={'text'}
          value={props.value || ''}
          autoComplete='off'
          onChange={(e: any) => handleChange(e.target.value)} />
        {focused && <ul className={styles.list}>
          {list && list.length > 0 ?
            list.map((suggestion, index) => {
              return (
                <li className={styles.item} key={index} onClick={() => handleClick(suggestion)}>
                  {suggestion}
                  {inputValue === suggestion && <svg xmlns="http://www.w3.org/2000/svg" className="tw-ml-auto tw-h-5 tw-w-5" viewBox="0 0 20 20" fill="#2bab66">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>}
                </li>
              )
            }) :
            <li className={styles.item}>Ingen resultater fundet</li>}
        </ul>}
      </div>
    </div>
  )
})

export default CustomDropdown
